/* __next_internal_client_entry_do_not_use__ Sticky auto */ import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PassiveScroll } from "@faire/retailer-visitor-shared/components/Scroll/Scroll";
import { throttleIfPossible } from "@faire/web--source/common/globals/throttleIfPossible";
import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
import { Column } from "@faire/web--source/slate/Layout";
import { useMergedRefs } from "@faire/web--source/ui/hooks/useMergedRefs";
import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
/**
 * Makes the children sticky (https://css-tricks.com/position-sticky-2/)
 * with the addition of a listener that notifies when the content is floating or not.
 */ export var Sticky = /*#__PURE__*/ React.forwardRef(function(props, ref) {
    var top = props.top, children = props.children, className = props.className, containerRef = props.containerRef, disabled = props.disabled, onFloatChange = props.onFloatChange, zIndex = props.zIndex;
    var _useState = _sliced_to_array(useState(false), 2), isFloating = _useState[0], setIsFloating = _useState[1];
    var stickyRef = useRef(null);
    var mergedRef = useMergedRefs(stickyRef, ref);
    // not using useCallback because we are using throttle
    // and useCallback requires an inlined function
    var handleScrollRef = useRef(undefined);
    useEffect(function() {
        handleScrollRef.current = buildScrollHandler(containerRef === null || containerRef === void 0 ? void 0 : containerRef.current, stickyRef.current, setIsFloating);
        return function() {
            if (handleScrollRef.current && "cancel" in handleScrollRef.current) {
                handleScrollRef.current.cancel();
            }
        };
    }, [
        containerRef,
        stickyRef
    ]);
    useEffect(function() {
        onFloatChange === null || onFloatChange === void 0 ? void 0 : onFloatChange(isFloating);
    }, [
        isFloating,
        onFloatChange
    ]);
    return /*#__PURE__*/ _jsxs(Container, {
        ref: mergedRef,
        $top: top,
        $zIndex: zIndex !== null && zIndex !== void 0 ? zIndex : 0,
        $disabled: disabled,
        className: className,
        children: [
            /*#__PURE__*/ _jsx(PassiveScroll, {
                onScroll: function() {
                    var _handleScrollRef_current;
                    return (_handleScrollRef_current = handleScrollRef.current) === null || _handleScrollRef_current === void 0 ? void 0 : _handleScrollRef_current.call(handleScrollRef);
                }
            }),
            children
        ]
    });
});
var buildScrollHandler = function(container, sticky, onFloatChange) {
    return throttleIfPossible(function() {
        var containerTop = container === null || container === void 0 ? void 0 : container.offsetTop;
        var headerTop = sticky === null || sticky === void 0 ? void 0 : sticky.offsetTop;
        if (isNotUndefined(containerTop) && isNotUndefined(headerTop)) {
            var absDiff = Math.abs(headerTop - containerTop);
            var isFloating = absDiff > STICKY_DETECTION_OFFSET_THRESHOLD;
            onFloatChange === null || onFloatChange === void 0 ? void 0 : onFloatChange(isFloating);
        }
    }, 50);
};
var STICKY_DETECTION_OFFSET_THRESHOLD = 2;
var Container = styled(Column).withConfig({
    componentId: "sc-2e02cbe1-0"
})([
    "position:",
    ";top:",
    "px;z-index:",
    ";"
], function(param) {
    var $disabled = param.$disabled;
    return $disabled ? "unset" : "sticky";
}, function(param) {
    var $top = param.$top;
    return $top;
}, function(param) {
    var $zIndex = param.$zIndex;
    return $zIndex;
});
